import Header from "./Header"
import "./SelectAudio.css"
import { audios } from "../../constants/app.config"
import GoHomeTimer from "./GoHomeTimer"
import { Screen, usePodContext } from "../PodContext"
import { useNavigate } from "react-router"
import Footer from "./Footer"

interface Audio {
  name: string;
  image: string;
  duration: string;
}

const SelectAudio = () => {
  const { setAudio } = usePodContext()
  const navigate = useNavigate()

  const selected = (audio: any) => {
    setAudio(audio)
    navigate(Screen.MEDITATION)
  }

  return (
    <div className="image-bg-container">
      <GoHomeTimer />
      <Header title="Select audio experience" progress={4} totalSteps={4} />
      <div className="vr-select-audio-container">
        <div className="vr-select-audio-carousel">
          {audios.map((audio: Audio) => (
            <button
              key={audio.name}
              className="vr-select-audio-option"
              style={{ backgroundImage: `url(${audio.image})` }}
              onClick={() => selected(audio)}
              aria-label="Select audio"
            >
            </button>
          ))}
        </div>
      </div>
      <Footer/>
    </div>
  )
}

export default SelectAudio
